import _ from "lodash";
import { graphql } from "lib/apolloClient";
import {
  getConfigurationQuery,
  getPreferenceQuery,
} from "ChildrenPage/modules/ChildrenPageQuery";
import {
  getConfigurationsFromCacheV2,
  getPreferencesFromCacheV2,
} from "ChildrenPage/modules/ChildrenPageGraphqlHelpers";
import { ENABLE_CONFIGURATION_FETCHING_OPTIMISATION } from "Constants/permissionConstants";
import ACLStore from "lib/aclStore";

const getConfigurationQueryEnhancer = (cb, config = {}) => {
  const {
    skipConfigurationQueryKey = "skipConfigurationQuery",
    configurationQueryVariablesKey = "configurationQueryVariables",
    fetchPolicy = "cache-and-network",
    isSettingsPage = false,
  } = config;
  return graphql(getConfigurationQuery, {
    name: "getConfiguration",
    skip: props => {
      return (
        _.get(props, skipConfigurationQueryKey) ||
        (!isSettingsPage &&
          ACLStore.can(ENABLE_CONFIGURATION_FETCHING_OPTIMISATION))
      );
    },
    options: props => {
      return {
        fetchPolicy: fetchPolicy,
        variables: _.get(props, configurationQueryVariablesKey),
        context: {
          useHttpLink: true,
        },
      };
    },
    props: params => {
      const { getConfiguration, ownProps } = params;
      const { isLoading, isData } = ownProps;
      const configurationResponse = getConfigurationsFromCacheV2(
        _.get(ownProps, configurationQueryVariablesKey)
      );
      const result = cb ? cb({ ...params, configurationResponse }) : {};
      return {
        getConfiguration,
        isData: isData && !_.isEmpty(configurationResponse),
        isLoading:
          _.includes([1, 2, 4], getConfiguration["networkStatus"]) || isLoading,
        ...result,
      };
    },
  });
};

const getPreferenceQueryEnhancer = (cb, config = {}) => {
  const {
    skipConfigurationQueryKey = "skipConfigurationQuery",
    configurationQueryVariablesKey = "configurationQueryVariables",
    fetchPolicy = "cache-and-network",
    isSettingsPage = false,
  } = config;
  return graphql(getPreferenceQuery, {
    name: "getPreference",
    skip: props =>
      _.get(props, skipConfigurationQueryKey) ||
      (!isSettingsPage &&
        ACLStore.can(ENABLE_CONFIGURATION_FETCHING_OPTIMISATION)),
    options: props => {
      return {
        fetchPolicy: fetchPolicy,
        variables: _.get(props, configurationQueryVariablesKey),
        context: {
          useHttpLink: true,
        },
      };
    },
    props: params => {
      const { getPreference, ownProps } = params;
      const { isLoading } = ownProps;
      const configurationResponse = getPreferencesFromCacheV2(
        _.get(ownProps, configurationQueryVariablesKey)
      );
      const result = cb ? cb({ ...params, configurationResponse }) : {};
      return {
        getPreference,
        isLoading:
          _.includes([1, 2, 4], getPreference["networkStatus"]) || isLoading,
        ...result,
      };
    },
  });
};

export { getConfigurationQueryEnhancer, getPreferenceQueryEnhancer };
